module.exports = __webpack_public_path__ + "img/artist-submits-mob.1af94a90.webp";